const SUPABASE_URL = 'https://smohhlblozzcmjrvntsb.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtb2hobGJsb3p6Y21qcnZudHNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ5NjA2ODcsImV4cCI6MjA5MDUzNjY4N30.YRWNdC2Zhrv4UhogmTdqe2AUko7sUVXbAWdARQyDK8w';

// Newsletter form — always opts in
document.querySelectorAll('.newsletter-form').forEach((form) => {
  form.addEventListener('submit', () => {
    const email = (form.querySelector('input[type="email"]').value || '').trim();
    if (!email) return;

    fetch(`${SUPABASE_URL}/rest/v1/subscribers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        Prefer: 'resolution=merge-duplicates,return=minimal',
      },
      body: JSON.stringify({ email, accepts_email_marketing: true }),
      keepalive: true,
    });
  });
});
